import { StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';

import { colors, spacing } from '@pletly/ui';
import { ExploreCommunities } from '../../explore';
import { YourCommunities } from '../../your';
import { TabBar } from './TabBar';

const Tab = createMaterialTopTabNavigator();

export const Groups = () => {
	const { t } = useTranslation();

	return (
		<Tab.Navigator
			tabBar={TabBar}
			style={styles.root}
			screenOptions={{ lazy: true, sceneStyle: styles.tabContainer }}
		>
			<Tab.Screen
				name={'explore'}
				options={{ title: t('community.explore') }}
				component={ExploreCommunities}
			/>
			<Tab.Screen
				name={'your'}
				options={{ title: t('community.your-communities') }}
				component={YourCommunities}
			/>
		</Tab.Navigator>
	);
};

const styles = StyleSheet.create({
	root: {
		marginTop: spacing(),
	},
	tabContainer: { backgroundColor: colors.transparent, paddingTop: spacing(2) },
});
